<template>
  <div style="background: #f2f2f6;height:calc(100vh - 60px);overflow-y:auto">
        <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>设备管理</el-breadcrumb-item>
  <el-breadcrumb-item>网关发货</el-breadcrumb-item>
</el-breadcrumb>
<el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item label="网关编号">
        <el-input style="width:100%" v-model="where.no" placeholder="" clearable></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="6">
       <el-form-item label="GUID编号">
    <el-input style="width:100%" v-model="where.srcaddress" placeholder="" clearable></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="6">
       <el-form-item label="厂家">
        <el-select
        clearable
        filterable
                v-model="where.factorycode"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in factorys"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
  </el-form-item>
    </el-col>
       <el-col :span="6" style="text-align:right">
        <el-button size="small" type="primary" @click="searchDeliver(1)">查询</el-button>
        <el-button type="success" size="mini" onclick="download('deliverList','网关详情记录')">导出</el-button>
      </el-form-item>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
        id="deliverList"
          :data="tabledata"
          ref="table"
          stripe
          border
          height="calc(100% - 237px)"

          style="font-size:12px; width: calc(100% - 60px); border-radius: 10px;margin:0 30px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }"
          class="el-table"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
        fixed
        width="50">
        <template slot="header" slot-scope="scope">
          <el-checkbox v-model="checkedAll"></el-checkbox>
      </template>
      <template slot-scope="scope">
        <el-checkbox v-model="scope.row.checked" @change="$forceUpdate()"></el-checkbox>
      </template>
    </el-table-column>
          <el-table-column
            type="index"
            fixed
            label="序号"
            :index="indexMethod"
            width="60"
          ></el-table-column>
          <el-table-column prop="srcaddress" label="网关编号" >
             <template slot-scope="scope">
               <span>{{scope.row.no}}</span>
               <!-- <br><span>ICCID: {{scope.row.iccid}}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="srcaddress" label="GUID编号" >
             <template slot-scope="scope">
               <span>{{scope.row.srcaddress}}</span>
               <!-- <br><span>ICCID: {{scope.row.iccid}}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="model" label="出库日期" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.delivertime||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="出库对象" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.name||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="出库批次" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.deliverno||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="撤回时间" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.revertedtime||'--'}}</span>
            </template>
          </el-table-column>
             <el-table-column
            column-key="opt"
            label="操作"
             width="75"
            >
            <template slot-scope="scope">
                <el-button v-if="!scope.row.revertedtime" style="font-size:12px" type="text" @click="revert(scope.row)">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
   <el-row>

        <el-pagination
          background
          :page-sizes="[20, 50, 100, 150, 200]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:20px"
        >
        </el-pagination>

    </el-row>
  </div>

</template>

<script>
import Vue from 'vue'
let customer
export default {
  name: 'Devices',
  data () {
    return {
      tabledata: [],
      factorys:[],
      pageset: {
        size: 20,
        index: 1
      },
      totalsize: 0,
      where: {
      },
    }
  },

  computed: {
  },
  mounted: function () {
    var self = this
    customer = window.localStorage.getItem('customer')
    if (customer) {
      Vue.axios
        .post('/factory/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.factorys = res.data.msgbody
          } else {
          }
        })
      this.searchDeliver()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  destroyed: function () {
   
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    searchDeliver (index) {
      if (index) {
        this.pageset.index = index
      }
      this.tabledata = []
      this.checkedAll = false
      Vue.axios
        .post('/equipment/deliver/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tabledata = res.data.msgbody
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/equipment/deliver/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchDeliver()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchDeliver()
    },
    revert(row){
      this.$confirm('分配网关将被还原, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Vue.axios
        .post('/equipment/revert', row)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: '撤回成功',
              type: 'success'
            })
            this.searchEquipment()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })

      }).catch(() => {

      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-table >>> .cell {
  padding: 0 !important;
}

.success{
  color:#67c23a
}

.danger{
  color:red
}

.info{
  color:gray
}

</style>



// WEBPACK FOOTER //
// src/components/Devices/DeliverList.vue